"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @class
 */
var DropMenuAlignment =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DropMenuAlignment, _PureComponent);

  function DropMenuAlignment() {
    _classCallCheck(this, DropMenuAlignment);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropMenuAlignment).apply(this, arguments));
  }

  _createClass(DropMenuAlignment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setAlignmentStyle();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setAlignmentStyle();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dropMenuRef = null;
    }
  }, {
    key: "setAlignmentStyle",
    value: function setAlignmentStyle() {
      var _this$props = this.props,
          _this$props$alignment = _this$props.alignment,
          alignment = _this$props$alignment === void 0 ? '' : _this$props$alignment,
          _this$props$show = _this$props.show,
          show = _this$props$show === void 0 ? false : _this$props$show,
          _this$props$dropMenuW = _this$props.dropMenuWidth,
          dropMenuWidth = _this$props$dropMenuW === void 0 ? 0 : _this$props$dropMenuW;
      var windowInnerWidth = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && window.innerWidth || 0;
      var dropMenuRect = {};
      var contentWidth = parseInt(dropMenuWidth, 10) || 0;

      if (windowInnerWidth > 0 && show && this.dropMenuRef && this.dropMenuRef.getBoundingClientRect) {
        dropMenuRect = this.dropMenuRef.getBoundingClientRect();

        if (!contentWidth) {
          contentWidth = dropMenuRect.width || 0;
        }

        if (contentWidth > 0) {
          if (alignment === 'right') {
            // macgic code兼容下拉面板可能是spaui-select的问题
            if (this.dropMenuRef.querySelector('.spaui-select') && dropMenuRect.height < 25) {
              this.dropMenuRef.style.top = "".concat(dropMenuRect.height, "px");
            }

            this.dropMenuRef.style.right = '0px';
          } else if (alignment === 'auto') {
            var rightSpace = dropMenuRect.left + contentWidth - windowInnerWidth;
            var leftSpace = contentWidth - dropMenuRect.left; // 如果往左边对齐的方式看见的内容更少，就换个方向

            if (rightSpace > 0 && rightSpace > leftSpace) {
              this.dropMenuRef.style.right = '0px';
            } // macgic code兼容下拉面板可能是spaui-select的问题


            if (this.dropMenuRef.querySelector('.spaui-select') && dropMenuRect.height < 25) {
              this.dropMenuRef.style.top = "".concat(dropMenuRect.height, "px");
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          alignment = _this$props2.alignment,
          show = _this$props2.show;

      if (children && show && (alignment === 'right' || alignment === 'auto')) {
        return _react["default"].createElement("div", {
          style: {
            position: 'absolute'
          },
          ref: function ref(el) {
            _this.dropMenuRef = el;
          }
        }, children);
      }

      return children;
    }
  }]);

  return DropMenuAlignment;
}(_react.PureComponent);

var _default = DropMenuAlignment;
exports["default"] = _default;